(function () {
    if (window.mobileMenuInitialized) {
        return;
    }
    window.mobileMenuInitialized = true;

    function initMobileMenuToggles() {
        document.querySelectorAll('.mobile-menu-toggle').forEach(function (button) {
            const newButton = button.cloneNode(true);
            button.parentNode.replaceChild(newButton, button);

            newButton.addEventListener('click', function () {
                const handle = this.getAttribute('data-handle');
                const parentHandle = this.getAttribute('data-parent-handle');
                const title = this.getAttribute('data-title');
                setActiveMobileItem(handle, title, parentHandle);
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initMobileMenuToggles();
            initMainMenuViewToggles();
        });
    } else {
        initMobileMenuToggles();
        initMainMenuViewToggles();
    }
})();

function initMainMenuViewToggles() {
    const mainMenu = document.getElementById('main-menu-list');
    const drawerHeader = document.querySelector('.mobile-nav-drawer .drawer-header');

    document.querySelectorAll('.submenu-toggle').forEach(toggle => {
        toggle.addEventListener('click', () => {
            if (mainMenu) mainMenu.classList.add('main-menu-hidden');
            if (drawerHeader) drawerHeader.classList.add('d-none');
        });
    });

    document.querySelectorAll('.close-submenu').forEach(closeBtn => {
        closeBtn.addEventListener('click', () => {
            if (mainMenu) mainMenu.classList.remove('main-menu-hidden');
            if (drawerHeader) drawerHeader.classList.remove('d-none');
        });
    });

    // Ensure header is shown if closed from submenu
    document.querySelectorAll('.close-mobile--navbar').forEach(closeBtn => {
        closeBtn.addEventListener('click', () => {
            if (drawerHeader) drawerHeader.classList.remove('d-none');
            if (mainMenu) mainMenu.classList.remove('main-menu-hidden');
        });
    });
}

function setActiveMobileItem(handle, title, parentHandle) {
    console.log('setActiveMobileItem called:', handle, title, parentHandle);

    const titleEl = document.getElementById('mobile-active-title-' + parentHandle);
    if (titleEl) {
        titleEl.innerText = title;
        // Reset animation for active title when tab switches
        setTimeout(() => {
            // Remove any inline opacity that might interfere
            titleEl.style.removeProperty('opacity');
            titleEl.style.animation = 'none';
            void titleEl.offsetWidth; // Trigger reflow
            titleEl.style.animation = null;
        }, 50);
    } else {
        console.error('mobile-active-title element not found for parent:', parentHandle);
    }

    const drilldown = document.getElementById('drilldown-' + parentHandle);
    if (drilldown) {
        drilldown.querySelectorAll('.mobile-content-block').forEach(el => el.classList.add('d-none'));
        drilldown.querySelectorAll('.inactive-nav-list button').forEach(el => el.classList.remove('d-none'));
    }

    const content = document.getElementById('content-' + parentHandle + '-' + handle);
    if (content) {
        content.classList.remove('d-none');
        console.log('Showing content for:', handle);
        
        // Reset animations for mobile menu items when content becomes visible
        setTimeout(() => {
            const animatedItems = content.querySelectorAll('.mobile-sub-item');
            animatedItems.forEach((item, index) => {
                item.style.animation = 'none';
                void item.offsetWidth; // Trigger reflow
                item.style.animation = null;
            });
        }, 50);
    } else {
        console.error('Content block not found for handle:', handle);
        console.log('Available content blocks:', Array.from(document.querySelectorAll('.mobile-content-block')).map(el => el.id));
    }

    const btn = document.getElementById('btn-' + parentHandle + '-' + handle);
    if (btn) {
        btn.classList.add('d-none');
        btn.classList.add('no-animate'); // Mark as clicked - don't animate when shown again
        console.log('Hiding button for:', handle);
    } else {
        console.error('Button not found for handle:', handle);
    }
}
